import * as Yup from "yup";
import {
  cvrField,
  pNumberField,
  remarksAndContactFields,
  requiredDate,
} from "./registrationValidationShared";

export const terminationSchema = Yup.object({
  name: Yup.string().required("Navn på virksomhed er påkrævet."),
  cvr: cvrField,
  pNumbers: Yup.array()
    .of(Yup.object({ value: pNumberField }))
    .min(1, "Angiv mindst ét P-nummer.")
    .required("P-nummer er påkrævet."),
  terminationDate: requiredDate,
  ...remarksAndContactFields,
});
